import cldr from "cldr-localenames-full/main/en/languages.json" with { type: "json" };
import z from "zod";

const languages = cldr.main.en.localeDisplayNames.languages;

export const IsoLanguageCodeSchema = z.enum(
    Object.keys(languages) as (keyof typeof languages)[],
);
export type IsoLanguageCode = z.infer<typeof IsoLanguageCodeSchema>;

export function isIsoLanguageCode(value: unknown): value is IsoLanguageCode {
    return IsoLanguageCodeSchema.safeParse(value).success;
}

// Our current needs are limited to getting the language name in English
// but function interface assumes future expansion hence the limited type parameter for target language
export function getIsoLanguageName(
    isoLanguageCode: IsoLanguageCode,
    targetLanguage: "en" = "en",
): string {
    return cldr.main[targetLanguage].localeDisplayNames.languages[isoLanguageCode];
}
